var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2026-09-04T06:44:44-main-bf1472a89"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["clashofclans-inbox@supercell"]={id:"2026-09-04T06:44:44-main-bf1472a89"};
      